import Vue from 'vue';
import firebase from 'firebase/app';
import 'firebase/auth';
import db from '@/firebase/init';
import { shortId } from '@/utils';

const state = () => ({
  boards: {}  // board firebase id to data
})

const getters = {

  getBoardById: (state) => (id) => {
    return state.boards[id];
  }
}

const actions = {

  fetchBoards(context) {
    let user = firebase.auth().currentUser;
    db.collection('boards')
      .where("userId", "==", user.uid)
      .get()
      .then((snapshot) => {
        if (!snapshot.empty) {
          let fetchedBoards = {};
          snapshot.forEach(doc => {
            fetchedBoards[doc.id] = doc.data();
          });
          context.commit('setBoards', fetchedBoards);
        }
      })
      .catch((err) => {
        console.log("Error fetching boards", err)
      })
  },

  createBoard(context) {
    let user = firebase.auth().currentUser;
    const newBoard = {
      userId: user.uid,
      boardName: "a board has no name",
      rows: [
        {
          id: shortId(),
          taskLists: [
            {
              id: shortId(),
              title: "",
              extra: "",
              tasks: []
            }
          ]
        }
      ]
    }
    let boardRef = db.collection('boards').doc();
    return boardRef.set(newBoard)
      .then(() => {
        context.commit('setBoard', {id: boardRef.id, board: newBoard});
        console.log(`Board ${boardRef.id} successfully created!`);
        return {id: boardRef.id}
      })
      .catch(function(error) {
        console.error("Error setting board: ", error);
      });
  },

  deleteBoard(context, {id}) {
    let boardRef = db.collection('boards').doc(id);
    return boardRef.delete().then(() => {
      // this.$message.success(`Board deleted!`);
      context.commit('removeBoard', {id});
      console.log(`Board ${id} successfully deleted!`);
    })
    .catch(function(error) {
      console.error(`Error removing board: `, error);
    })
    ;
  },

  saveBoard(context, {id, board}) {
    let boardRef = db.collection('boards').doc(id);
    boardRef.set(board)
      .then(() => {
        context.commit('setBoard', {id, board});
        console.log(`Board ${id} successfully saved!`);
      })
      .catch(function(error) {
        console.error("Error setting board: ", error);
      });
  },

}

const mutations = {

  // boards
  setBoard(state, {id, board}) {
    Vue.set(state.boards, id, board);
  },
  setBoards(state, boards) {
    state.boards = boards;
  },
  removeBoard(state, {id}) {
    Vue.delete(state.boards, id);
  },
  editBoard(state, {board, key, value}) {
    Vue.set(board, key, value);
  },

  // rows
  addRow(state, {rows, position, row}) {
    rows.splice(position, 0, row);
  },
  removeRow(state, {rows, id}) {
    for (var i = rows.length - 1; i >= 0; i--) {
      if (rows[i].id === id) {
        rows.splice(i, 1);
        break;
      }
    }
  },

  // taskLists
  addTaskList(state, {taskLists, position, taskList}) {
    taskLists.splice(position, 0, taskList);
  },
  editTaskList(state, {taskList, key, value}) {
    Vue.set(taskList, key, value);
  },
  removeTaskList(state, {taskLists, id}) {
    for (var i = taskLists.length - 1; i >= 0; i--) {
      if (taskLists[i].id === id) {
        taskLists.splice(i, 1);
        break;
      }
    }
  },

  // tasks
  addTask(state, {taskList, position, task}) {
    taskList.tasks.splice(position, 0, task);
  },
  editTask(state, {task, key, value}) {
    Vue.set(task, key, value);
  },
  removeTask(state, {taskList, position}) {
    taskList.tasks.splice(position, 1);
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
